import {
    options_premium_DeleteAccountPopup_Title,
    options_premium_DeleteAccountPopup_Description,
    options_premium_DeleteAccount_Text,
    options_premium_DeleteAllAccount_Text,
    options_premium_CancelAccountDelete_Text,
    options_premium_AddAdditionalMailboxesText,
} from './CloudCacheOptionFull.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ActionButton, DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { store } from '../store/store';

import { removeCloudCacheAccount } from '../actions/removeCloudCacheAccount';
import { getCloudCacheAccount } from '../actions/getCloudCacheAccount';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { getModuleUrl } from '../utils/getModuleUrl';
import { Link } from 'office-ui-fabric-react/lib/Link';

const styles = require('./CloudCacheOptionFull.scss');

export interface DeleteCloudCacheAccountDialogState {
    hideDialog: boolean;
}

@observer
export default class CloudCacheOptionFull extends React.Component<
    {},
    DeleteCloudCacheAccountDialogState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            hideDialog: true,
        };
    }

    componentDidMount() {
        getCloudCacheAccount(getUserConfiguration().SessionSettings.WebSessionType);
    }

    render() {
        if (store.cloudCacheConfigItem.emailAddress) {
            return (
                <div>
                    <div className={styles.container}>
                        <Label>{store.cloudCacheConfigItem.emailAddress}</Label>

                        <ActionButton
                            onClick={this.showDialog}
                            iconProps={{
                                iconName: ControlIcons.Delete,
                                styles: { root: styles.actionButton },
                            }}
                            styles={{
                                label: styles.actionLabel,
                            }}
                        />
                    </div>
                    <div>
                        <Dialog
                            hidden={this.state.hideDialog}
                            title={loc(options_premium_DeleteAccountPopup_Title)}
                            subText={loc(options_premium_DeleteAccountPopup_Description)}
                            className={styles.dialog}
                            onDismiss={this.closeDialog}>
                            <DialogFooter>
                                <PrimaryButton
                                    text={loc(options_premium_DeleteAccount_Text)}
                                    className={styles.footerButton}
                                    onClick={this.removeAccount}
                                />
                                <DefaultButton
                                    text={loc(options_premium_DeleteAllAccount_Text)}
                                    className={styles.footerButton}
                                    onClick={this.removeAllAccounts}
                                />
                                <DefaultButton
                                    text={loc(options_premium_CancelAccountDelete_Text)}
                                    className={styles.footerButton}
                                    onClick={this.closeDialog}
                                />
                            </DialogFooter>
                        </Dialog>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={styles.container}>
                    <Link
                        data-is-focusable="true"
                        href={getModuleUrl(WebSessionType.GMail)}
                        target="blank">
                        {loc(options_premium_AddAdditionalMailboxesText)}
                    </Link>
                </div>
            );
        }
    }

    private showDialog = (): void => {
        this.setState({
            hideDialog: false,
        });
    };

    private closeDialog = (): void => {
        this.setState({
            hideDialog: true,
        });
    };

    private removeAccount = (): void => {
        removeCloudCacheAccount();
        this.closeDialog();
    };

    private removeAllAccounts = (): void => {
        removeCloudCacheAccount();
        this.closeDialog();
    };
}
